// Splash screen images
import floertSplashBg from './floert_splash_bg.png'
import floertSplashText from './floert_splash_text.png'
import floertSplashSparkle from './floert_splash_sparkle.png'
import floertSplashPeachShine from './floert_splash_peach_shine.png'

// Main view images
import floertBg from './floert_bg.png'
import floertText from './floert_text.png'

// Profile images
import img1 from './img1.jpg'
import img2 from './img2.jpg'
import img3 from './img3.jpg'
import img4 from './img4.png'
import img5 from './img5.jpg'
import img6 from './img6.png'
import img7 from './img7.jpg'

// Splash screen exports
export const splashImages = {
  bg: floertSplashBg,
  text: floertSplashText,
  sparkle: floertSplashSparkle,
  peachShine: floertSplashPeachShine
}

// Main view exports
export const mainImages = {
  bg: floertBg,
  text: floertText
}

// Profile images map - maps the JSON path to the imported image
export const profileImages: Record<string, string> = {
  '/assets/img1.jpg': img1,
  '/assets/img2.jpg': img2,
  '/assets/img3.jpg': img3,
  '/assets/img4.png': img4,
  '/assets/img5.jpg': img5,
  '/assets/img6.png': img6,
  '/assets/img7.jpg': img7
}

// All images for preloading
export const allImages = [
  floertSplashBg,
  floertSplashText,
  floertSplashSparkle,
  floertSplashPeachShine,
  floertBg,
  floertText,
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7
]
